module.exports = __webpack_public_path__ + "img/no-products-search-state.1d3febad.svg";